import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Ingresar from './paginas/Ingresar';
import CambiarPassword from './paginas/CambiarPassword';
import MisTramites from './paginas/MisTramites';
import { hayToken, leerSesion } from './api';

/**
 * Con sesión o al login.
 *
 * Esto es comodidad, no seguridad: quien quiera puede quitar el candado en su propio navegador.
 * Lo que de verdad protege los datos está en el backend, que a este rol solo le contesta en
 * /api/portal y solo con lo de su empresa. Aquí se evita que alguien vea una pantalla rota.
 */
function ConSesion({ children }) {
  const donde = useLocation();
  if (!hayToken()) return <Navigate to="/ingresar" replace state={{ desde: donde }} />;

  // Con la contraseña temporal solo se puede hacer una cosa: cambiarla. El backend además lo
  // exige por su cuenta (no entrega ni un trámite hasta entonces); esto es para que el cliente
  // no se tope con una pantalla vacía sin saber qué le falta.
  const sesion = leerSesion();
  if (sesion?.debeCambiarPassword && donde.pathname !== '/cambiar-contrasena') {
    return <Navigate to="/cambiar-contrasena" replace />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/ingresar" element={<Ingresar />} />
      <Route
        path="/cambiar-contrasena"
        element={<ConSesion><CambiarPassword /></ConSesion>}
      />
      <Route
        path="/"
        element={<ConSesion><MisTramites /></ConSesion>}
      />
      {/* Cualquier otra cosa cae al inicio: el portal es una sola pantalla. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
